import { EmbedVideoBlockSchema } from '@blocksuite/affine-model';
import { SlashMenuConfigExtension } from '@blocksuite/affine-widget-slash-menu';
import { BlockViewExtension, FlavourExtension } from '@blocksuite/std';
import type { ExtensionType } from '@blocksuite/store';
import { literal } from 'lit/static-html.js';

import { createBuiltinToolbarConfigExtension } from '../configs/toolbar';
import { embedVideoSlashMenuConfig } from './configs/slash-menu';
import { EmbedVideoBlockInteraction } from './embed-edgeless-video-block';
import { EmbedVideoBlockComponent } from './embed-video-block';
import {
  EmbedVideoBlockOptionConfig,
  EmbedVideoBlockService,
} from './embed-video-service';

const flavour = EmbedVideoBlockSchema.model.flavour;

export const EmbedVideoViewExtensions: ExtensionType[] = [
  FlavourExtension(flavour),
  EmbedVideoBlockService,
  BlockViewExtension(flavour, model => {
    return literal`affine-embed-video-block`;
    return model.parent?.flavour === 'affine:surface'
      ? literal`affine-embed-edgeless-video-block`
      : literal`affine-embed-video-block`;
  }),
  EmbedVideoBlockOptionConfig,
  createBuiltinToolbarConfigExtension(flavour, EmbedVideoBlockComponent),
  SlashMenuConfigExtension('affine:embed-video', embedVideoSlashMenuConfig),
  EmbedVideoBlockInteraction,
].flat();
